import React from "react";
import "./SelectField.scss";
import Select from "react-select";
import { useSelectField } from "./SelectFieldLogic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";

export const SelectField = ({
  value,
  onChange = () => {},
  options = [],
  idKey,
  nameKey,
  placeholder,
  isRequired = false,
  label = null,
  isDisabled = false,
  isSearchable = true,
  errorMessage = undefined,
}) => {
  const { items, selectedItem } = useSelectField({
    options,
    valueKey: idKey,
    labelKey: nameKey,
    value,
  });

  const selectedValue =
    value === "" || value === null || value === undefined
      ? null
      : items.find((item) => item.value === value) || null;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border:
        state.isFocused || errorMessage !== undefined
          ? `1px solid ${
              errorMessage !== undefined ? "#dc3545" : "#7647ee"
            } !important`
          : "1px solid #cccccc",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #7647ee !important",
        boxShadow: "none",
      },
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#8b8b8b",
      fontWeight: 400,
    }),

    option: (styles, { isFocused }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#7647ee" : null,
        color: isFocused ? "#fff" : null,
      };
    },
  };

  return (
    <div className="custom-dropdown">
      {label !== null && (
        <label htmlFor="" data-testid="label">
          {isRequired && <span className="text-danger">*</span>}
          <span>{label}</span>
        </label>
      )}
      <Select
        className="custom-dropdown__select"
        classNamePrefix="custom-dropdown__select"
        options={items}
        onChange={(answer) => onChange(answer.value, answer.label)}
        value={selectedValue}
        defaultValue={selectedItem ? { label: selectedItem } : undefined}
        placeholder={placeholder || "Select"}
        isDisabled={isDisabled}
        label={label}
        styles={customStyles}
        isSearchable={isSearchable}
      />
      {/* error message */}
      <p
        className={`error-message text-danger ${
          errorMessage !== undefined ? "show" : ""
        }`}
        data-testid="error-message"
      >
        {errorMessage !== undefined && (
          <motion.span initial={{ x: -10 }} animate={{ x: 0 }}>
            <FontAwesomeIcon
              icon={["fas", "exclamation-circle"]}
              className="mr-2"
              style={{ fontSize: "13px" }}
            />
            {errorMessage !== undefined && <span>{errorMessage.message}</span>}
          </motion.span>
        )}
      </p>
    </div>
  );
};
